import React from 'react';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableHead from '@material-ui/core/TableHead';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import { withStyles } from '@material-ui/core/styles';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { dollars } from 'utils/money';
import Typography from '@material-ui/core/Typography'
import Divider from '@material-ui/core/Divider';
import moment from 'moment';
import { startCase } from 'lodash';
import EnhancedTable from '../Table';
import { fetchApplications, filterApplications } from 'actions/applications';
import Search from '@material-ui/icons/Search';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

const styles = theme => ({
  headerButton: {
    float: 'right'
  },
  flex: {
    flex: 1
  },
  heading: {
    display: 'flex',
    justifyContent: 'space-between',
    margin: '10px',
    alignItems: 'center'
  },
  row: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.background.default,
    },
  }
});

const colNames = [
  { id: 'number', type: 'string', label: 'Number' },
  { id: 'form.businessName', type: 'string', label: 'Company' },
  { id: 'status', type: 'string', label: 'Status' },
  { id: 'form.amount', type: 'number', label: 'Amount' },
  { id: 'lodgedAt', type: 'date', label: 'Lodgement Date' },
  { id: 'form.drawdownDate', type: 'date', label: 'Drawdown Date' }
];

class List extends React.Component {
  componentDidMount = () => {
    this.props.dispatch(
      fetchApplications({
        appType: 'referral',
        status: ['draft', 'lodged', 'approved', 'authorized', 'quoted', 'doc_requested', 'rejected', 'complete']
      })
    );
  };

  renderApplication = (application) => {
    const form = application.form
    return (
      <TableRow className={this.props.classes.row} key={application.number}>
        <TableCell>
          <Link to={`/applications/${application.number}`}>
            {application.number}
          </Link>
        </TableCell>
        <TableCell>
          {form.businessName}
        </TableCell>
        <TableCell>
          {application.status}
        </TableCell>
        <TableCell>
          {dollars(form.amount)}
        </TableCell>
        <TableCell>
          {application.lodgedAt && moment(application.lodgedAt).format('DD/MM/YYYY')}
        </TableCell>
        <TableCell>
          {moment(form.drawdownDate).format('DD/MM/YYYY')}
        </TableCell>
      </TableRow>
    );
  }

  handleSearch = (e) => {
    const term = e.target.value;
    this.props.dispatch(filterApplications({"form.businessName": term}));
  }

  renderHeading = () => {
    return (
      <div className={this.props.classes.heading}>
        <Typography variant='headline'>
          Applications
        </Typography>
        <div>
          <Grid container spacing={8} alignItems="flex-end">
            <Grid item>
              <Search />
            </Grid>
            <Grid item>
              <TextField id="input-with-icon-grid" label="Company" onChange={(e)=>this.handleSearch(e)} />
            </Grid>
          </Grid>
        </div>
      </div>
    );
  }

  render = () => {
    const { applications, classes } = this.props;
    if (!applications) {
      return null;
    }
    return (
      <EnhancedTable data={applications} renderHeading={this.renderHeading} renderRow={this.renderApplication} colNames={colNames}/>
    );
  };
}

const mapStateToProps = (state) => {
  const applications = state.applications && state.applications.list;
  return { applications };
};

const styled = withStyles(styles)(List)
const connected = connect(mapStateToProps)(styled);
export default connected;



// WEBPACK FOOTER //
// ./src/components/Applications/List.js